import { DEFAULT_LANG, LOCALE_MAPPING } from "@dtm-frontend/shared/ui/i18n";
import { AzureMapsOptions, AzureMapsTileset } from "../../shared/models/azure-maps.models";

export const AZURE_MAPS_LAYER_OPTIONS: Partial<AzureMapsOptions> = {
    language: LOCALE_MAPPING[DEFAULT_LANG],
    tilesetId: AzureMapsTileset.BaseRoad,
};
